import { render, staticRenderFns } from "./DashCalidad.vue?vue&type=template&id=f331c106&"
import script from "./DashCalidad.vue?vue&type=script&lang=js&"
export * from "./DashCalidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports